/**
 *
 * Asynchronously loads the component for AnswerSessionPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
